
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { DashboardClient, DeferredPaymentClient } from '@/services/Services';
import { Prop } from "vue-property-decorator";
import store from '@/store';

@Options({})
export default class payWithSaldo extends Vue {

    saldo: number = 0;
    
    acquistiInAttesa: OM.DeferredPayment[] = [];

    created(){
        DeferredPaymentClient.getPendingByCustomer(store.state.user.identifier)
        .then(x => {
            this.acquistiInAttesa = x;
        })
        DashboardClient.getDashPortafoglio(store.state.user.identifier)
        .then(x => {
            this.saldo = x.saldoAttuale;
        })
    }

    pay(){
        this.$emit('pay', this.saldo)
    }

};
